import * as React from 'react';
import { SwitchContainer, SwitchLabel, SwitchRail, SwitchDot } from './Switch.styles.js';

var Switch = function (_a) {
    var _b = _a.darkMode, darkMode = _b === void 0 ? false : _b, _c = _a.variant, variant = _c === void 0 ? "default" : _c, _d = _a.checked, checked = _d === void 0 ? false : _d, _e = _a.labelText, labelText = _e === void 0 ? "" : _e, _f = _a.labelType, labelType = _f === void 0 ? "caption" : _f, _g = _a.disabled, disabled = _g === void 0 ? false : _g, onCheckedChange = _a.onCheckedChange;
    var switchId = React.useId();
    return (React.createElement(SwitchContainer, { "data-testid": "switch container" },
        labelText ? (React.createElement(SwitchLabel, { role: "tooltip", type: labelType, htmlFor: switchId }, labelText)) : null,
        React.createElement(SwitchRail, { darkMode: darkMode, variant: variant, disabled: disabled, checked: checked, onCheckedChange: onCheckedChange, id: switchId, "aria-label": labelText || "switch" },
            React.createElement(SwitchDot, { darkMode: darkMode, variant: variant }))));
};

export { Switch as default };
//# sourceMappingURL=Switch.js.map
